<template>
    <div v-if="scores.total == 0" id="loading-screen" class="wrapper">
        <h1>One moment...</h1>
    </div>
    <div v-else class="wrapper">
        <nav>
            <div class="nav-content">
                <button @click="backToForm()">🡨</button>
                <div>
                    <h1>The language learning search</h1>
                    <h5>by Ciprian Corobca</h5>
                </div>
            </div>
            <div class="separator"></div>
        </nav>
        <div v-if="!targetKnown" class="main-results">
            <dt>The difficulty of learning {{ target }} is</dt>
            <dd :class="overallClass">{{overallDiff}}</dd>
        </div>
        <div v-else class="main-results" >
            <dt>You already know {{ target }}</dt>
        </div>
        <div v-if="!targetKnown" class="specific-results">
            <div class="separator"></div>
            <h4>Per competency</h4>
            <div id="reading-accolade" class="accolade">
                <dt id="reading-lbl">Reading:</dt><dd :class="readingClass">{{readingDiff}}</dd>
            </div>
            <div id="writing-accolade" class="accolade">
                <dt id="writing-lbl">Writing:</dt><dd :class="writingClass">{{writingDiff}}</dd>
            </div>
            <div id="speaking-accolade" class="accolade">
                <dt id="speaking-lbl">Speaking:</dt><dd :class="speakingClass">{{speakingDiff}}</dd>
            </div>
            <div id="listening-accolade" class="accolade">
                <dt id="listening-lbl">Listening:</dt><dd :class="listeningClass">{{listeningDiff}}</dd>
            </div>
            <div id="grammar-accolade" class="accolade">
                <dt id="grammar-lbl">Grammar:</dt><dd :class="grammarClass">{{grammarDiff}}</dd>
            </div>
            <div class="separator"></div>
        </div>
        <h4 id="you">Your profile</h4>
        <language-accolade v-for="(language,index) in languageArray" :key="index" :index="index"/>
    </div>
</template>

<script setup>
    import LanguageAccolade from './LanguageAccolade.vue';
    import { languageStore } from '@/stores/languages';
    import { computed } from 'vue';
    import router from '@/router';

    var languageArray = languageStore().languages;
    const scores = languageStore().scores;
    const target = languageStore().targetLanguage;
    const targetKnown = computed(() => {
        if(Number(scores.total) == -1) return true; 
        else return false;
    });

    const readingDiff = computed(() => {
        if(Number(scores.reading) <= 0.4) return "Very Hard";
        else if(Number(scores.reading) > 0.4 && Number(scores.reading) <= 0.75) return "Hard";
        else if(Number(scores.reading) > 0.75 && Number(scores.reading) <= 1.3) return "Medium";
        else return "Easy";
    });
    const writingDiff = computed(() => {
        if(Number(scores.writing) <= 0.4) return "Very Hard";
        else if(Number(scores.writing) > 0.4 && Number(scores.writing) <= 0.75) return "Hard";
        else if(Number(scores.writing) > 0.75 && Number(scores.writing) <= 1.3) return "Medium";
        else return "Easy";
    });
    const speakingDiff = computed(() => {
        if(Number(scores.speaking) <= 0.4) return "Very Hard";
        else if(Number(scores.speaking) > 0.4 && Number(scores.speaking) <= 0.75) return "Hard";
        else if(Number(scores.speaking) > 0.75 && Number(scores.speaking) <= 1.3) return "Medium";
        else return "Easy";
    });
    const listeningDiff = computed(() => {
        if(Number(scores.listening) <= 0.4) return "Very Hard";
        else if(Number(scores.listening) > 0.4 && Number(scores.listening) <= 0.75) return "Hard";
        else if(Number(scores.listening) > 0.75 && Number(scores.listening) <= 1.3) return "Medium";
        else return "Easy";
    });
    const grammarDiff = computed(() => {
        if(Number(scores.grammar) <= 0.4) return "Very Hard";
        else if(Number(scores.grammar) > 0.4 && Number(scores.grammar) <= 0.75) return "Hard";
        else if(Number(scores.grammar) > 0.75 && Number(scores.grammar) <= 1.3) return "Medium";
        else return "Easy";
    });

    const readingClass = computed(() => {
        if(Number(scores.reading) <= 0.4) return "veryhard";
        else if(Number(scores.reading) > 0.4 && Number(scores.reading) <= 0.75) return "hard";
        else if(Number(scores.reading) > 0.75 && Number(scores.reading) <= 1.3) return "medium";
        else return "easy";
    });
    const writingClass = computed(() => {
        if(Number(scores.writing) <= 0.4) return "veryhard";
        else if(Number(scores.writing) > 0.4 && Number(scores.writing) <= 0.75) return "hard";
        else if(Number(scores.writing) > 0.75 && Number(scores.writing) <= 1.3) return "medium";
        else return "easy";
    });
    const speakingClass = computed(() => {
        if(Number(scores.speaking) <= 0.4) return "veryhard";
        else if(Number(scores.speaking) > 0.4 && Number(scores.speaking) <= 0.75) return "hard";
        else if(Number(scores.speaking) > 0.75 && Number(scores.speaking) <= 1.3) return "medium";
        else return "easy";
    });
    const listeningClass = computed(() => {
        if(Number(scores.listening) <= 0.4) return "veryhard";
        else if(Number(scores.listening) > 0.4 && Number(scores.listening) <= 0.75) return "hard";
        else if(Number(scores.listening) > 0.75 && Number(scores.listening) <= 1.3) return "medium";
        else return "easy";
    });
    const grammarClass = computed(() => {
        if(Number(scores.grammar) <= 0.4) return "veryhard";
        else if(Number(scores.grammar) > 0.4 && Number(scores.grammar) <= 0.75) return "hard";
        else if(Number(scores.grammar) > 0.75 && Number(scores.grammar) <= 1.3) return "medium";
        else return "easy";
    });

    const overallDiff = computed(() => {
        if(Number(scores.total) <= 0.4) return "Very Hard";
        else if(Number(scores.total) > 0.4 && Number(scores.total) <= 0.75) return "Hard";
        else if(Number(scores.total) > 0.75 && Number(scores.total) <= 1.3) return "Medium";
        else return "Easy";
    });
    const overallClass = computed(() => {
        if(Number(scores.total) <= 0.4) return "veryhard";
        else if(Number(scores.total) > 0.4 && Number(scores.total) <= 0.75) return "hard";
        else if(Number(scores.total) > 0.75 && Number(scores.total) <= 1.3) return "medium";
        else return "easy";
    });

    const backToForm = () => {
        router.push('/');
    };
</script>

<style scoped>
    h1,h3,h4,h5,dt,dd
    {
        margin:0;
        cursor:default;
        font-family: Playfair Display;
    }

    nav
    {
        width:100%;
        position:sticky;
        top:0;
        flex-shrink: 0;
        z-index: 10;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        background-color: #fbdfca;
    }

    .nav-content
    {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap:10px;
    }

    .nav-content div
    {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .wrapper
    {
        width:min(400px,100vw);
        margin-inline: auto;
        display:flex;
        flex-direction: column;
        align-items: center;
        gap:8px;
        padding-bottom:max(15px, env(safe-area-inset-bottom, 15px));
    }

    #loading-screen.wrapper
    {
        padding-top: 25vh;
    }

    .main-results
    {
        height:150px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap:20px;
        width:100%;
        padding:0 5px;
    }

    .specific-results
    {
        display:grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 2px 3fr 2fr 2fr 2fr 2fr 2fr 2px;
        height:230px;
        width: 100%;
        padding:0 5px;
    }

    h1
    {
        font-size: 24px;
    }

    h5
    {
        font-size: 14px;
    }

    h4
    {
        font-size:24px;
    }

    dd
    {
        text-shadow: 0px 1px 4px rgb(0 0 0 / 80%);
    }

    dt,h1,h3,h4,h5
    {
        user-select: none;
    }

    #you
    {
        align-self: flex-start;
        padding:0 5px;
    }

    .main-results dt
    {
        font-size: 24px;
    }

    .main-results dd
    {
        font-size: 60px;
    }

    .specific-results dt,.specific-results dd
    {
        font-size:25px;
    }

    .specific-results dd
    {
        text-indent: 4px;
    }

    .specific-results h4
    {
        grid-area: 2 / 1 / 3 / -1;
        align-self: center;
    }

    #reading-accolade
    {
        grid-area: 3 / 1 / 4 / -1;
    }

    #writing-accolade
    {
        grid-area: 4 / 1 / 5 / -1;
    }

    #speaking-accolade
    {
        grid-area: 5 / 1 / 6 / -1;
    }

    #listening-accolade
    {
        grid-area: 6 / 1 / 7 / -1;
    }

    #grammar-accolade
    {
        grid-area: 7 / 1 / 8 / -1;
    }

    .separator
    {
        height:0;
        width:90%;
        border:1px solid rgba(0, 0, 0, 0.481);
    }

    .specific-results > .separator:first-child
    {
        grid-area: 1 / 1 / 2 / -1;
        justify-self: center;
    }

    .specific-results > .separator:last-child
    {
        grid-area: 8 / 1 / -1 / -1;
        justify-self: center;
    }

    .nav-content button
    {
        height:69%;
        aspect-ratio: 1 / 1;
        background: #00000000;
        border-radius: 50%;
        font-size: 20px;
        cursor: pointer;
        border:2px solid black;
    }

    .nav-content button:hover
    {
        background-color: #00000020;
    }

    .accolade
    {
        display:flex;
    }

    .easy
    {
        color:#b1f55e;
    }

    .medium
    {
        color:#f5e85e;
    }

    .hard
    {
        color:#f5845e;
    }

    .veryhard
    {
        color:#f55e9d;
    }

    @media (max-width:370px)
    {
        h1
        {
            font-size: 18px;
        }
    }

    @media (max-width:300px)
    {
        .specific-results
        {
            grid-template-rows: 2px 1fr 2fr 2fr 2fr 2fr 2fr 2px;
        }

        h1
        {
            font-size: 14px;
        }

        h4
        {
            font-size:13px;
        }

        h5
        {
            font-size: 10px;
        }

        .main-results dt
        {
            font-size: 18px;
        }

        .main-results dd
        {
            font-size: 40px;
        }

        .specific-results dt,.specific-results dd
        {
            font-size:18px;
        }

        .main-results
        {
            height:200px;
        }
    }

    @media (max-width:240px)
    {
        h1
        {
            font-size: 12px;
        }
    }

    @media (max-width:210px)
    {
        h1
        {
            font-size: 9px;
        }

        h5 
        {
            font-size: 7px;
        }
    }

    @media (max-width:162px)
    {
        h1
        {
            font-size: 14px;
        }
    }
</style>